module.exports = {
  title: 'Торнадо',
  validators: {
    required: 'Это поле обязательно к заполнению',
    passwordMustMatch: 'Пароль должен совпадать',
    invalidEmail: 'Неверный адрес электронной почты',
    maxLength: 'Поле не должно превышать {length} символов',
    minValue: 'Допустимое минимальное значение {value}',
    minArrayValue: 'Выберите как минимум {value} элемент | {value} элемента',
    minValueExcluded: 'Значение должно быть больше {value}',
    maxValue: 'Допустимое максимальное значение {value}',
    maxValueExcluded: 'Значение должно быть меньше {value}',
    selectAtLeastOne: 'Выберите хотя бы один вариант',
    firstName: 'Требуется имя',
    lastName: 'Требуется фамилия',
    notAvailableAtThisDate: 'Не доступен(-на) в указанную дату ({date})',
    priceIsNotSetAtThisDate: 'Цена не установлена для указанной даты ({date})',
    requiredPriceDefinition: 'Цена не определена в системе',
    cashBoxAmountValidator: `Значения в колонке 'Фактически' должны быть заполнены и не быть отрицательными`,
  },
  errorMessages: {
    validators: {
      keys: {
        orderItems: `"Список заказов"`,
        privileges: `"Список привилегий"`,
        overprice: `"Наценочная цена"`,
        price: `"Цена"`,
        fromPrice: `"Цена от"`,
        toPrice: `"Цена до"`,
        wholesalePrice: `"Оптовая цена"`,
        quantity: `"Количество"`,
        discount: `"Скидка"`,
        paginationSkip: `"Пропуск пагинации"`,
        paginationTake: `"Количество пагинации"`,
        reviewStars: `"Отзыв"`,
        products: `"Товаров"`,
        level: '"Уровень"',
        minDirectReferrals: '"Минимальное количество прямых рефералов"',
        minNetworkPurchases: '"Минимальная сумма сетевых покупок"',
        minPersonalPurchases: '"Минимальная сумма личных покупок"',
        reachedBonus: '"Полученный бонус"',
        bonus: '"Бонус"'
      },
      ArrayMinSize: 'Минимальный размер {key} должен быть больше или равен {value}',
      MinFieldEq: '{key} должен быть больше или равен {value}',
      MinExclude: '{key} должен быть больше {value}',
      Min: '{key} должен быть больше или равен {value}',
      Max: '{key} должен быть меньше или равен {value}',
    },
    notFound: {
      keys: {
        user: 'Пользователь',
        home: '"Главная" страница',
        client: 'Клиент',
        coupon: 'Купон',
        branch: 'Филиал',
        order: 'Заказ',
        about: 'Одна из страниц "О нас"',
        product: 'Товар',
        contact: 'Контакт',
        faq: 'Одна из страниц "FAQ"',
        request: 'Запрос',
        funFact: 'Одна из страниц "Интересный факт"',
        project: 'Проект',
        whyWe: 'Одна из страниц "Почему мы"',
        service: 'Одна из страниц "Услуга"',
        skillMain: 'Страница "Навык"',
        staff: 'Персонал',
        skill: 'Навык',
        socialLink: 'Социальная сеть',
        userGroup: 'Группа пользователей',
        testimonial: 'Отзыв',
        productBrand: 'Бренд товара',
        productReview: 'Отзыв о товаре',
        productCategory: 'Категория товара',
        mainCurrency: 'Основная валюта',
        currency: 'Валюта',
        feature: 'Условие',
        productReviewReply: 'Ответ на отзыв о товаре',
        productSubcategory: 'Подкатегория товара',
        blog: 'Блог',
        pricePolicy: 'Политика цен',
        productPrice: 'Цена товара',
        orderPayment: 'Оплата заказа',
        orderItem: 'Товар заказа',
        publicOffer: 'Публичная оферта',
        privacyPolicy: 'Политика конфиденциальности',
        color: 'Цвет',
        image: 'Изображение',
        banner: 'Баннер',
				arrival: 'Поступление',
        coinTransaction: 'Транзакция монеты',
        productPriceCoinsPolicy: 'Цена товара монетами',
        level: 'Уровень',
        referralBonusPolicy: 'Правило реферального бонуса',
        purchaseTransaction: 'Платежная транзакция',
        arrivalProductMarkup: 'Авто-наценка прихода товара'
      },
      message: '{key} не найден'
    },
    'Failed to fetch': 'У вас проблемы с подключением, проверьте интернет и попробуйте снова',
    FILE_FORMAT_IS_NOT_ALLOWED: 'Этот тип файла не поддерживается',
    FILE_SIZE_EXCEEDED_MAX_LIMIT: 'Файл слишком большой для загрузки',
    CLIENT_ALREADY_EXISTS: 'Пользователь с таким email уже существует в системе',
    INVALID_CREDENTIALS: 'Введенный email или пароль неверны',
    INVALID_REFRESH_TOKEN: 'Сессия истекла или недействительна. Пожалуйста, войдите снова',
    RESET_TOKEN_FORBIDDEN: 'Сброс пароля недоступен для этого аккаунта',
    BRANCH_ID_REQUIRED: 'Пожалуйста, выберите филиал для продолжения',
    ORDER_CAN_NOT_BE_COMPLETED: 'Этот заказ не может быть выполнен в данный момент',
    ORDER_CAN_NOT_BE_CANCELED: 'Этот заказ не может быть отменен',
    ORDER_CAN_NOT_BE_RETURNED: 'Этот заказ не может быть возвращен',
    INSUFFICIENT_ROLE: 'У вас недостаточно прав для выполнения этого действия',
    USER_GROUP_ALREADY_EXISTS: 'Эта группа пользователей уже существует',
    USER_GROUP_CAN_NOT_BE_DELETED_BECAUSE_OF_ACTIVE_USERS: 'Вы не можете удалить эту группу, так как в ней есть активные пользователи',
    CAN_NOT_REMOVE_ACTUAL_USER: 'Вы не можете удалить текущего активного пользователя',
    INVALID_OWNERSHIP: 'У вас нет прав владения для выполнения этого действия',
    INVALID_RESET_TOKEN: 'Ссылка для сброса пароля недействительна или истекла',
    PRODUCT_CATEGORY_OR_SUBCATEGORY_REQUIRED: 'Необходимо указать категорию или подкатегорию товара',
    REQUIRED_LATIN_SYMBOLS: 'Нужна хотя бы 1 английская буква для "Названия" на английском',
    CANNOT_REMOVE_LAST_ORDER_ITEM: 'Нельзя удалить, нужен хотя бы 1 товар в заказе',
    ORDER_HAS_ALREADY_LINKED_TO_CLIENT: 'Заказ уже привязан к клиенту',
    PRODUCT_WITH_CONFIG_IS_EXISTS: 'Товар с теми же данными цветов, объемов и размеров уже есть.',
    ANY_TITLE_REQUIRED: 'Нужно название хотя бы на одном языке.',
    ANY_DESCRIPTION_SHORT_REQUIRED: 'Нужно короткое описание хотя бы на одном языке.',
    ANY_DESCRIPTION_REQUIRED: 'Нужно описание хотя бы на одном языке.',
		BRANCH_ALREADY_ASSIGNED: 'Приход товара уже привязан к этому филиалу. Невозможно переместить в тот же филиал.',
		QUANTITY_IS_TOO_BIG: 'Запрошенное количество превышает доступное количество в приходе.',
		ARRIVAL_STATUS_CANNOT_BE_SAME: 'Новый статус не может совпадать с текущим статусом.',
		MOVED_OR_SOLD_BY_ORDER_ARRIVAL_CANNOT_BE_CHANGED: 'Невозможно изменить приход, который уже перемещен или продан по заказу.',
		ARRIVAL_STATUS_MUST_BE_SOLD_OR_LOST: 'Статус прихода может быть изменен только на "Продан" или "Потерян".',
    blog_duplicate_title_en_idx: 'Название блога на английском языке должен быть уникальным. Пожалуйста, выберите другой название.',
    blog_duplicate_title_ru_idx: 'Название блога на русском языке должен быть уникальным. Пожалуйста, выберите другой название.',
    blog_duplicate_title_kg_idx: 'Название блога на кыргызском языке должен быть уникальным. Пожалуйста, выберите другой название.',
    blog_duplicate_alt_idx: 'Название блога (slugify) должен быть уникальным. Пожалуйста, измените английский название.',
    blog_time_to_read_gte_0: 'Время на чтение блога не может быть отрицательным.',
    blog_word_count_gte_0: 'Количество слов в блоге не может быть меньше нуля.',
    client_register_confirm_code_email_unique_idx: 'Ошибка регистрации, этот адрес электронной почты уже зарегистрирован.',
    client_reset_token_email_unique_idx: 'Ошибка сброса пароля, уже существует активный токен сброса для этого email.',
    client_email_duplicate_idx: 'Этот адрес электронной почты уже используется. Пожалуйста, используйте другой адрес.',
    client_cart_product_duplicate_idx: 'Невозможно добавить один и тот же товар в корзину больше одного раза.',
    client_cart_quantity_gt_0: 'Количество товаров в корзине должно быть больше нуля.',
    client_wishlist_product_duplicate_idx: 'Невозможно добавить один и тот же товар в список желаемого больше одного раза.',
    branch_duplicate_title_en_idx: 'Название филиала на английском языке должен быть уникальным. Пожалуйста, выберите другой название.',
    branch_duplicate_title_ru_idx: 'Название филиала на русском языке должен быть уникальным. Пожалуйста, выберите другой название.',
    branch_duplicate_title_kg_idx: 'Название филиала на кыргызском языке должен быть уникальным. Пожалуйста, выберите другой название.',
    order_item_quantity_gt_0: 'Количество товаров в заказе должно быть больше нуля.',
    order_item_price_gte_0: 'Цена товара в заказе должна быть больше или равна нулю.',
    order_total_price_gte_0: 'Общая сумма заказа должна быть больше или равна нулю.',
    order_price_without_coupon_limit: 'Цена без скидки должна быть больше или равна общей сумме заказа.',
    product_brand_duplicate_title_en_idx: 'Название бренда товара на английском языке должен быть уникальным. Пожалуйста, выберите другой название.',
    product_brand_duplicate_title_ru_idx: 'Название бренда товара на русском языке должен быть уникальным. Пожалуйста, выберите другой название.',
    product_brand_duplicate_title_kg_idx: 'Название бренда товара на кыргызском языке должен быть уникальным. Пожалуйста, выберите другой название.',
    product_brand_duplicate_alt_idx: 'Slugify название бренда товара должно быть уникальным. Пожалуйста, измените английское название.',
    product_category_duplicate_title_en_idx: 'Название категории товара на английском языке должен быть уникальным. Пожалуйста, выберите другой название.',
    product_category_duplicate_title_ru_idx: 'Название категории товара на русском языке должен быть уникальным. Пожалуйста, выберите другой название.',
    product_category_duplicate_title_kg_idx: 'Название категории товара на кыргызском языке должен быть уникальным. Пожалуйста, выберите другой название.',
    product_category_duplicate_alt_idx: 'Slugify название категории товара должно быть уникальным. Пожалуйста, измените английское название.',
    product_price_price_gte_0: 'Цена товара должна быть больше или равна нулю.',
    product_price_overprice_limit: 'Переплата должна быть либо null, либо больше или равна обычной цене.',
    product_price_product_currency_uk: 'Цена товара должна быть уникальной для каждой валюты.',
    product_subcategory_duplicate_title_en_idx: 'Название подкатегории товара на английском языке должен быть уникальным. Пожалуйста, выберите другой название.',
    product_subcategory_duplicate_title_ru_idx: 'Название подкатегории товара на русском языке должен быть уникальным. Пожалуйста, выберите другой название.',
    product_subcategory_duplicate_title_kg_idx: 'Название подкатегории товара на кыргызском языке должен быть уникальным. Пожалуйста, выберите другой название.',
    product_subcategory_duplicate_alt_idx: 'Slugify название подкатегории товара должно быть уникальным. Пожалуйста, измените английское название.',
    product_info_duplicate_title_en_idx: 'Название товара на английском языке должен быть уникальным. Пожалуйста, выберите другой название.',
    product_info_duplicate_title_ru_idx: 'Название товара на русском языке должен быть уникальным. Пожалуйста, выберите другой название.',
    product_info_duplicate_title_kg_idx: 'Название товара на кыргызском языке должен быть уникальным. Пожалуйста, выберите другой название.',
    product_info_duplicate_alt_idx: 'Slugify название товара должно быть уникальным. Пожалуйста, измените английское название.',
    product_quantity_gt_0: 'Количество товара должно быть null или больше нуля.',
    product_discount_limit: 'Скидка на товар должна быть либо null, либо значение от 0 до 1.',
    product_subcategory_or_category: 'Товар должен принадлежать либо категории, либо подкатегории.',
    product_review_value_limit: 'Значение отзыва о товаре должно быть больше 0 и меньше или равно 5.',
    product_review_product_client_uk: 'Вы не можете оставить отзыв, так как уже оставили его.',
    user_group_privilege_alt_duplicate_idx: 'Привилегия с альтернативным текстом должна быть уникальной.',
    user_email_duplicate_idx: 'Этот адрес электронной почты уже зарегистрирован в системе. Пожалуйста, используйте другой адрес.',
    order_discount_limit: 'Скидка заказа должна быть между 0 и 100%',
    client_coins_balance_min: 'Баланс монет не может быть отрицательным.',
    client_total_earned_coins_min: 'Общее количество заработанных монет не может быть отрицательным.',
    client_direct_referrals_count_min: 'Количество прямых рефералов не может быть отрицательным.',
    client_total_personal_purchases_min: 'Общая сумма личных покупок не может быть отрицательной.',
    client_total_network_purchases_min: 'Общая сумма сетевых покупок не может быть отрицательной.',
    INVALID_PASSWORD: 'Неверный пароль.',
    UQ_client_level_title: 'Уровень с таким названием уже существует.',
    client_level_level_min: 'Уровень не может быть отрицательным.',
    client_level_min_direct_referrals_min: 'Минимальное число прямых рефералов не может быть отрицательным.',
    client_level_min_personal_purchases_min: 'Минимальная сумма личных покупок не может быть отрицательной.',
    client_level_min_network_purchases_min: 'Минимальная сумма сетевых покупок не может быть отрицательной.',
    product_price_coins_policy_discount_limit: 'Скидка должна быть от 0 до 1.',
    uk_product_price_coins_policy_level_id: 'Политика оплаты монетами для этого уровня уже существует.',
    referral_bonus_policy_bonus_limit: 'Бонус должен быть от 0 до 1.',
    UQ_referral_bonus_policy_level_id: 'Правило реферального бонуса для этого уровня уже существует.',
    purchase_transaction_amount_min: 'Сумма покупки должна быть больше нуля.',
    coin_transaction_amount_gt_0: 'Сумма монет в транзакции должна быть больше нуля.',
    ORDER_BONUS_ALREADY_USED: 'Бонус для заказа уже использован',
    ORDER_CLIENT_NOT_FOUND_FOR_BONUS: 'Клиент заказа не найден для отправки бонуса',
    ORDER_IS_NOT_FULLY_PAID_FOR_BONUS: 'Заказ не полностью оплачен для бонуса',
    NOT_ENOUGH_COINS: 'Недостаточно монет на балансе клиента',
    REQUIRED_BOTH_PRICE_CURRENCY_IF_SET_ARRIVAL: 'Себестоимость и валюта должны быть указаны, если определена хотя бы одна из них',
    PRODUCT_IDS_REQUIRED: 'Требуются ID товаров.',
    ALL_PRODUCT_IDS_NOT_FOUND: 'Все товары по указанным ID не найдены'
  },
  toast: {
    imageUpdated: 'Изображение обновлено',
    imageDataUpdated: 'Данные изображения обновлены',
    dataSaved: 'Данные сохранены',
    configDataSame: 'Данные конфигурации (объем, размер, цвет) не должны быть одинаковыми',
    selfProductRequired: 'Привязывающий товар необходим',
    catalogExported: 'Каталог экспортирован'
  },
  toolbar: {
    tabs: {
      admin: 'Администрация',
      finance: 'Финансы',
      shop: 'Магазин'
    },
  },
  languages: {
    middle: {
      en: 'англ',
      ru: 'рус',
      kg: 'кырг'
    },
    long: {
      en: 'Английский',
      ru: 'Русский',
      kg: 'Кыргызский'
    }
  },
  currency: {
    EUR: 'Евро',
    CNY: 'Китайский юань',
    KZT: 'Казахский тенге',
    KGS: 'Кыргызский сом',
    KRW: 'Южнокорейская вона',
    RUB: 'Российский рубль',
    TRY: 'Турецкая лира',
    GBP: 'Британский фунт',
    UZS: 'Узбекский сум',
    USD: 'Доллар США'
  },
  country: {
    AL: 'Албания',
    AM: 'Армения',
    AT: 'Австрия',
    AU: 'Австралия',
    BH: 'Бахрейн',
    BY: 'Беларусь',
    BE: 'Бельгия',
    BR: 'Бразилия',
    BG: 'Болгария',
    CA: 'Канада',
    CN: 'Китай',
    HR: 'Хорватия',
    CY: 'Кипр',
    CZ: 'Чехия',
    DK: 'Дания',
    EG: 'Египет',
    EE: 'Эстония',
    FR: 'Франция',
    DE: 'Германия',
    GE: 'Грузия',
    GR: 'Греция',
    HK: 'Гонконг',
    HU: 'Венгрия',
    IN: 'Индия',
    ID: 'Индонезия',
    IT: 'Италия',
    JP: 'Япония',
    KZ: 'Казахстан',
    KR: 'Южная Корея',
    KG: 'Кыргызстан',
    LU: 'Люксембург',
    MY: 'Малайзия',
    PL: 'Польша',
    PT: 'Португалия',
    RU: 'Россия',
    ES: 'Испания',
    CH: 'Швейцария',
    TJ: 'Таджикистан',
    TH: 'Таиланд',
    TR: 'Турция',
    AE: 'ОАЭ',
    US: 'США',
    UZ: 'Узбекистан'
  },
  date: {
    months: {
      short: ['янв', 'фев', 'мар', 'апр', 'май', 'июнь', 'июль', 'авг', 'сен', 'окт', 'ноя', 'дек'],
      full: ['январь', 'февраль', 'март', 'апрель', 'май', 'июнь', 'июль', 'август', 'сентябрь', 'октябрь', 'ноябрь', 'декабрь'],
    },
    days: {
      short: ['вс', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб'],
    },
    times: {
      short: {
        days: 'д.',
        hours: 'ч.',
        minutes: 'м.',
        seconds: 'с.'
      }
    },
  },
  common: {
    loading: 'Загрузка',
    noData: 'Нет данных',
    confirmDialog: 'Вы уверены, что хотите продолжить эту операцию?',
    deletionConfirmation: 'Вы уверены, что хотите удалить?',
    softDeletionConfirmation: 'Вы уверены, что хотите показать/скрыть?',
    oops: 'Упс',
    accessDenied: 'Доступ запрещен',
    pageNotFound: 'Страница не найдена',
    pc: 'шт',
    none: 'Нет',
		all: 'Все'
  },
  types: {
    system: {
      SHOP: 'panda.kg'
    },
    project: {
      IMAGE: 'Изображение',
      YOUTUBE: 'Ютуб'
    },
    productStatuses: {
      IN_STOCK: 'В наличии',
      OUT_OF_STOCK: 'Нет в наличии',
      ON_ORDER: 'На заказ',
      COMING_SOON: 'Ждём поступления',
    },
    productTags: {
      SALE: 'Акция',
      NEW: 'Новинка',
      HOT: 'Хит',
      EXCLUSIVE: 'Эксклюзив',
      LIMITED: 'Ограничено',
      BEST_PRICE: 'Лучшая цена'
    },
    paymentTypes: {
      CASH: 'Наличными',
      NON_CASH: 'Безналичными'
    },
    discountTypes: {
      WHOLESALE: 'Оптом',
      SALE: 'Акция',
      COUPON: 'Купон',
      PRICE_POLICY: 'Ценовая политика'
    },
    orderStatuses: {
      PENDING: 'В ожидании',
      PREPARING: 'Готовится',
      READY: 'Готов',
      IN_DELIVERY: 'В доставке',
      DELIVERED: 'Доставлено',
      COMPLETED: 'Завершено',
      RETURNED: 'Возвращено',
      CANCELED: 'Отменено',
      NOT_REGISTERED: 'Не зарегистрирован'
    },
    orderStatusPayments: {
      NO: 'Не оплачено',
      PART: 'Частично оплачено',
      YES: 'Полностью оплачено'
    },
    cashOnsInfo: {
      DELIVERY: 'Оплата',
      CHECK: 'Оплата',
      SELF_DELIVERY: 'Оплата'
    },
    clientTypes: {
      REGULAR: 'Обычный',
      WHOLESALER: 'Оптовик',
      ADMIN: 'Админ',
      LOYAL: 'Постоянник'
    },
    nodePositions: {
      LEFT: 'Слева',
      RIGHT: 'Справа',
      CENTER: 'В центре',
      LEFT_WITH_TEXT: 'Слева с текстом',
      RIGHT_WITH_TEXT: 'Справа с текстом'
    },
		arrivalStatuses: {
			SOLD: 'Продан',
			LOST: 'Потерян',
			MOVED: 'Перемещен',
			SOLD_BY_ORDER: 'Продан через заказ'
		},
		arrivalHistoryActions: {
      CREATED: 'Создан',
      UPDATED: 'Обновлен',
      CHANGED_STATUS: 'Статус изменен',
      MOVED: 'Перемещен',
      ORDERED: 'Продан',
      REMOVED: 'Удален',
      RETURNED: 'Возвращен',
      CANCELLED: 'Отменен',
      CREATED_ORDER_ITEM: 'Добавлен в заказ',
      UPDATED_ORDER_ITEM: 'Обновлен товар в заказе',
      REMOVED_ORDER_ITEM: 'Удален из заказа'
		},
    coinTransactions: {
      REFERRAL_BONUS: 'Реферальный бонус',
      PURCHASE: 'Покупка монет',
      ORDER_BONUS: 'Бонус с заказа',
      MANUAL: 'Ручной перевод',
      USED: 'Использовано'
    },
    arrivalHistory: {
      productId: 'ID товара',
      productTitle: 'Товар',
      branchTitle: 'Филиал',
      quantity: 'Количество',
      buyPrice: 'Себестоимость',
      currency: 'Валюта',
      note: 'Примечание',
      arrivedAt: 'Дата прибытия',
      oldQuantity: 'Старое количество',
      oldBuyPrice: 'Старая себестоимость',
      oldCurrency: 'Старая валюта',
      oldNote: 'Старое примечание',
      oldArrivedAt: 'Старая дата прибытия',
      status: 'Статус',
      oldStatus: 'Старый статус',
      oldArrivalId: 'ID старого прихода',
      oldBranchTitle: 'Старый филиал',
      orderId: 'ID заказа',
      orderUid: 'Заказ №',
      arrivals: 'Поступления',
      orderItemId: 'ID товара заказа',
      newQuantity: 'Новое количество',
      split: 'Был разделен',
      newArrivalId: 'ID нового прихода',
      remainingQuantity: 'Оставшееся количество',
      arrivalId: 'ID прихода',
      restoredQuantity: 'Восстановленное количество',
    },
    whatsappErrors: {
      USER_NOT_FOUND: 'Номера нет в Whatsapp',
      BLOCKED: 'Клиент заблокировал наш номер',
      UNDELIVERABLE: 'Неудалось отправить - номер не существует',
      INACTIVE: 'Номер неактивен / удалил Whatsapp',
      TEMPLATE_REJECTED: 'Шаблон отклонен',
      RATE_LIMIT: 'Достигли лимит посылок',
      OTHER: 'Отправка уведомлений в Whatsapp провалено'
    }
  },
  auth: {
    login: 'Вход',
    loggingOut: 'Выход...',
    passwordRecovery: 'Восстановление пароля',
    rememberYourPassword: 'Помните свой пароль?',
    instructionDescription: 'Инструкции по восстановлению пароля были отправлены. Пожалуйста, проверьте свою электронную почту',
    goToLoginScreen: 'Перейти на экран входа',
    passwordRecoveryConfirmation: 'Подтверждение восстановления пароля',
    invalidResetTokenDescription: 'Неверный токен. Пожалуйста, попробуйте восстановить пароль снова',
    goToPasswordRecoveryScreen: 'Перейти на экран восстановления пароля',
    changePassword: 'Изменить пароль',
    yourPasswordSuccessfullyChanged: 'Ваш пароль был успешно изменен',
  },
  pages: {
    pages: 'Страницы',
    home: 'Главная',
    aboutUs: 'О нас',
    whyWe: 'Почему мы?',
    services: 'Услуги',
    features: 'Условия',
    contacts: 'Контакты',
    socialLinks: 'Социальные сети',
    portfolio: 'Портфолио',
    skills: 'Навыки',
    testimonials: 'Отзывы',
    funFacts: 'Достижения',
    faq: 'Вопросы и ответы',
    team: 'Команда',
    userManagement: 'Управление пользователями',
    users: 'Пользователи',
    userGroups: 'Группы пользователей',
    mainDescription: 'Выберите нужную конфигурацию',
    settings: 'Настройки',
    publicOffer: 'Публичная оферта',
    privacyPolicy: 'Политика конфиденциальности'
  },
  shop: {
    orders: 'Заказы',
    products: 'Товары',
    onlineShop: 'Интернет магазин',
		arrivals: 'Складской учёт',
		inWarehouse: 'В наличии',
		soldLost: 'Списанные',
    miniCatalog: 'Мини каталог',
    blog: 'Блог',
    clients: 'Клиенты',
    history: 'История',
    requests: 'Запросы',
    panda: 'Panda',
    shop: 'Магазин',
    settings: 'Настройки',
    productsCategories: `Категории товаров`,
    productsSubcategories: `Подкатегории товаров`,
    productsBrands: `Бренды товаров`,
    coupons: 'Купоны',
    branches: 'Филиалы',
    requestsFromShop: 'Запросы от panda.kg',
    shownInDetails: 'будет отображаться в деталях',
    productReviews: 'Отзывы товаров',
    colors: 'Цвета',
    banners: 'Баннеры',
    arrivalProductMarkups: 'Авто-наценка прихода товаров',
    individual: 'Индивидуально',
    fromToPrice: 'От/до цены'
  },
  finance: {
    currencies: 'Валюты',
    arrivalProductMarkup: 'Авто-наценка товаров',
    policies: 'Правила',
    pricePolicy: 'Общие скидки для заказов',
    priceCoinsPolicy: 'Скидки товаров за монеты',
    referralBonusPolicy: 'Правила реферальных бонусов',
    clientLevelRules: 'Правила уровней',
    finance: 'Финансы',
    rates: 'Курсы',
    exchangeRates: 'Курсы валют',
    coinRates: 'Курсы монеты',
    transactions: 'Транзакции',
    coins: 'Монеты',
    purchases: 'Деньги',
    purchaseTransactions: 'Транзакции платежей',
    coinTransactions: 'Транзакции монет'
  },
  modals: {
    user: {
      add: 'Добавить нового пользователя',
      edit: 'Редактировать пользователя'
    },
    userGroup: {
      add: 'Добавить новую группу',
      edit: 'Редактировать группу'
    },
    aboutUs: {
      add: 'Добавить новую информацию о нас',
      edit: 'Редактировать информацию о нас'
    },
    whyWe: {
      add: 'Добавить новую информацию о нас',
      edit: 'Редактировать информацию о нас'
    },
    service: {
      add: 'Добавить новую услугу',
      edit: 'Редактировать услугу'
    },
    feature: {
      add: 'Добавить новое условие',
      edit: 'Редактировать условие'
    },
    product: {
      add: 'Добавить новый товар',
      edit: 'Редактировать товар',
      duplicate: 'Дублировать товар и привязать друг к другу',
      connect: 'Привязать товары друг к другу',
      editInfo: 'Редактировать общую информацию',
      updateImages: 'Обновить изображения товара'
    },
		arrival: {
			add: 'Добавить новое поступление',
			edit: 'Редактировать поступление',
			changeStatus: 'Изменить статус',
			moveTo: 'Переместить в другой филиал'
		},
    arrivalProductMarkup: {
      add: 'Добавить новую авто-наценку',
      edit: 'Редактировать авто-наценку',
    },
    blog: {
      add: 'Добавить новый блог',
      edit: 'Редактировать блог',
      updateImages: 'Обновить главное изображение блога'
    },
    project: {
      add: 'Добавить новый проект',
      edit: 'Редактировать проект'
    },
    testimonial: {
      add: 'Добавить новый отзыв',
      edit: 'Редактировать отзыв'
    },
    skill: {
      add: 'Добавить новый навык',
      edit: 'Редактировать навык'
    },
    contact: {
      add: 'Добавить новый контакт',
      edit: 'Редактировать контакт'
    },
    socialLink: {
      add: 'Добавить новую социальную сеть',
      edit: 'Редактировать социальную сеть'
    },
    faq: {
      add: 'Добавить новый вопрос и ответ',
      edit: 'Редактировать вопрос и ответ'
    },
    funFact: {
      add: 'Добавить новое достижение',
      edit: 'Редактировать достижение'
    },
    staff: {
      add: 'Добавить нового сотрудника',
      edit: 'Редактировать сотрудника'
    },
    client: {
      add: 'Добавить нового клиента',
      edit: 'Редактировать клиента',
      ban: 'Вы уверены, что хотите заблокировать этого клиента?',
      unban: 'Вы уверены, что хотите разблокировать этого клиента?',
      editBalance: 'Редактировать баланс клиента'
    },
    productBrand: {
      add: 'Добавить новый бренд товара',
      edit: 'Редактировать бренд товара'
    },
    productCategory: {
      add: 'Добавить новую категорию товара',
      edit: 'Редактировать категорию товара'
    },
    banner: {
      add: 'Добавить новый баннер',
      edit: 'Редактировать баннер'
    },
    productSubcategory: {
      add: 'Добавить новую подкатегорию товара',
      edit: 'Редактировать подкатегорию товара'
    },
    branch: {
      add: 'Добавить новый филиал',
      edit: 'Редактировать филиал'
    },
    color: {
      add: 'Добавить новый цвет',
      edit: 'Редактировать цвет'
    },
    coupon: {
      add: 'Добавить новый купон',
      edit: 'Редактировать купон'
    },
    request: {
      info: 'Информация о запросе',
      fromSystem: 'Из системы',
      notAnswered: 'Еще не отвечено',
      answered: 'Уже отвечено'
    },
    currency: {
      add: 'Добавить новую валюту',
      edit: 'Редактировать валюту'
    },
		exchangeRates: {
			add: 'Добавить новый обмен валют',
		},
    coinRates: {
      add: 'Добавить новый курс валют для монеты',
    },
    order: {
      edit: 'Редактировать заказ',
      return: 'Возврат заказа',
      cancel: 'Отменить заказ',
      returnInfo: 'Вы уверены, что хотите вернуть заказ? Пожалуйста, укажите причину:',
      cancelInfo: 'Вы уверены, что хотите отменить заказ? Пожалуйста, укажите причину:',
      complete: 'Вы хотите завершить заказ?',
      completeDesc: 'Вы уверены, что клиент получил свой заказ?',
      bonusNotSent: 'Бонус этого заказа еще не отправлен',
      sendBonus: 'Вы уверены, что хотите рассчитать и отправить бонусы клиенту этого заказа и его рефералу?',
      register: 'Зарегистрировать заказ?',
      registerDesc: 'Вы уверены, что это обговорено с клиентом и нет уже такого же открытого заказа?',
      status: 'Изменить статус заказа',
      paymentAdd: 'Добавить оплату',
      paymentEdit: 'Редактировать оплату',
      itemAdd: 'Добавить товар в заказ',
      itemEdit: 'Редактировать товар заказа',
      statusInfo: 'Статус заказа',
      statusPaymentInfo: 'Оплаты заказа',
      orderItems: 'Товары заказа',
      details: 'Детали заказа',
      linkOrderToClient: 'Привязать клиента к заказу'
    },
    pricePolicy: {
      add: 'Добавить новую ценовую политику',
      edit: 'Редактировать ценовую политику'
    },
    productPriceCoinsPolicy: {
      add: 'Добавить новую скидку товаров за монеты',
      edit: 'Редактировать скидку товаров за монеты'
    },
    clientLevel: {
      add: 'Добавить новый уровень клиента',
      edit: 'Редактировать уровень клиента'
    },
    referralBonusPolicy: {
      add: 'Добавить новое правило реферального бонуса',
      edit: 'Редактировать правило реферального бонуса'
    },
    productReview: {
      edit: 'Редактировать отзыв о товаре',
      replies: 'Ответы отзывов',
      editReply: 'Редактировать ответ отзыва о товаре'
    },
  },
  userGroups: {
    manager: 'Менеджер',
    admin: 'Администратор',
    other: 'Другое',
  },
  editor: {
    default: 'Нормальный',
    defaultShort: 'нор',
    byDefault: 'Обычный',
    bold: 'Жирный',
    italic: 'Курсив',
    strikethrough: 'Зачеркнутый',
    underline: 'Подчеркнутый',
    heading: 'Заголовок',
    normalText: 'Обычный текст',
    heading1: 'Заголовок 1',
    heading2: 'Заголовок 2',
    heading3: 'Заголовок 3',
    heading4: 'Заголовок 4',
    heading5: 'Заголовок 5',
    heading6: 'Заголовок 6',
    fontSize: 'Размер шрифта',
    increaseFontSize: 'Увеличить размер шрифта',
    decreaseFontSize: 'Уменьшить размер шрифта',
    textColor: 'Цвет текста',
    highlightColor: 'Цвет выделения',
    align: 'Выравнивание',
    leftAlign: 'Выравнивание по левому краю',
    centerAlign: 'Выравнивание по центру',
    rightAlign: 'Выравнивание по правому краю',
    justify: 'Выравнивание по ширине',
    fontStyle: 'Стиль шрифта',
    lineSpacing: 'Межстрочный интервал',
    checklist: 'Список задач',
    bulletedList: 'Маркированный список',
    numberedList: 'Нумерованный список',
    horizontalRule: 'Горизонтальная линия',
    blockquote: 'Цитата',
    code: 'Код',
    codeBlock: 'Блок кода',
    hyperlink: 'Гиперссылка',
    button: 'Кнопка',
    table: 'Таблица',
    editTable: 'Редактировать таблицу',
    insertTable: 'Вставить таблицу',
    removeTable: 'Удалить таблицу',
    toggleHeaderRow: 'Переключить строку заголовка',
    toggleHeaderColumn: 'Переключить колонку заголовка',
    toggleHeaderCell: 'Переключить ячейку заголовка',
    insertColumnLeft: 'Вставить колонку слева',
    insertColumnRight: 'Вставить колонку справа',
    removeSelectedColumns: 'Удалить выбранные колонки',
    insertRowUp: 'Вставить строку вверх',
    insertRowDown: 'Вставить строку вниз',
    removeSelectedRows: 'Удалить выбранные строки',
    mergeCells: 'Объединить ячейки',
    splitCell: 'Разделить ячейку',
    cellColor: 'Цвет ячейки',
    borderColor: 'Цвет рамки таблицы',
    borderWidth: 'Ширина рамки таблицы',
    noBorder: 'Без рамок',
    borderStyle: 'Стиль рамки таблицы',
    addGrid: 'Вставить сетку',
    insertImage: 'Вставить изображение',
    insertVideo: 'Вставить видео',
    insertAudio: 'Вставить аудио',
    insertYoutubeVideo: 'Вставить Youtube видео',
    translate: 'Перевести',
    rephrase: 'Перефразировать',
    addEmoji: 'Добавить эмодзи',
    undo: 'Отменить',
    redo: 'Повторить'
  },
  fileBrowser: {
    deletion: 'Удаление',
    selectFolderOrFile: 'Выберите папку или файл',
    noFilesOrFoldersFound: 'Файлы или папки не найдены',
    folderIsEmpty: 'Папка пуста',
    deleteDescription: 'Вы уверены, что хотите удалить <b>{type}</b>?<br><em>{baseName}</em>',
    thisFolder: 'эту папку',
    thisFile: 'этот файл',
    upTo: 'До: {value}',
    uploadTo: 'Загрузить в:',
    maxFilesCount: 'Максимальное количество файлов: {value}',
    maxFileSize: 'Максимальный размер файла: {value}',
  },
  formLabels: {
		note: 'Примечание',
		restoring: 'Восстановление',
    texture: 'Текстура',
    latitude: 'Latitude',
    longitude: 'Longitude',
    postalCode: 'Почтовый индекс',
    itemPosition: 'Позиция',
    images: 'Картинки',
    file: 'Файл',
    size: 'Размер',
    filter: 'Фильтр',
    from: 'От',
    to: 'До',
    sum: 'Сумма',
    currency: 'Валюта',
    paymentType: 'Тип оплаты',
    bonus: 'Бонус',
    bonusForRef: 'Бонус рефералу',
    totalIncome: 'Общая прибыль',
    discountType: 'Тип скидки',
    notes: 'Примечание',
    enterComment: 'Введите комментарий',
    date: 'Дата',
    searchByTitle: 'Поиск по названию',
    refund: 'Возврат',
    cashBox: 'Кассовый аппарат',
    title: 'Название',
    firstName: 'Имя',
    lastName: 'Фамилия',
    telNumber: 'Телефонный номер',
    email: 'Электронная почта',
    userGroup: 'Группа пользователей',
    privileges: 'Привилегии',
    yourEmail: 'Ваша электронная почта',
    password: 'Пароль',
    enterYourEmail: 'Введите вашу электронную почту',
    enterNewPassword: 'Введите новый пароль',
    confirmYourNewPassword: 'Подтвердите новый пароль',
    subtitle: 'Подзаголовок',
    location: 'Местоположение',
    coverImage: 'Изображение обложки',
    backgroundImage: 'Фоновое изображение',
    shopBackgroundImage: 'Фоновое изображение магазина',
    primaryLogo: 'Основной логотип',
    secondaryLogo: 'Вторичный логотип',
    primaryShopLogo: 'Основной логотип магазина',
    secondaryShopLogo: 'Вторичный логотип магазина',
    description: 'Описание',
    quote: 'Цитата',
    experienceYear: 'Опыт с (пр. 2010)',
    showInHome: 'Использовать на странице "Главная"',
    isAboutPage: 'Использовать на странице "О нас"',
    isWhyWe: `Использовать на секции "Почему мы"`,
    symbolLeft: 'Символ слева от цены',
    example: 'Пример',
    exampleVideoUrl: 'Выделите 11-значный код из ссылки как выделено внизу красными буквами и вставьте в поле',
    profession: 'Профессия',
    image: 'Изображение',
    tags: 'Краткие комментарии',
    blogTags: 'Тэги (можно делить запятыми)',
    keywordsBlogHint: 'Укажите 3–5 уникальных и подходящих слова для этого блога, которые отражают его тему. Разделяйте запятыми без пробела.',
    keywordsProductHint: 'Укажите 3-5 уникальных и подходящих слова для этого товара, которые отражают его. Разделяйте запятыми без пробела.',
    isService: 'Использовать на странице "Услуги"',
    videoImage: 'Изображение видео',
    urlVideo: 'ID из ссылки на видео (YouTube)',
    percent: 'Процент',
    telegram: 'Ссылка на Telegram',
    whatsapp: 'Ссылка на WhatsApp',
    showInSites: 'Показывать на сайтах',
    showInAbouts: 'Показывать на стр. "О нас"',
    iconSearchHint: 'Иконку можно найти:',
    here: 'здесь',
    mainContact: 'Основной контакт',
    leftImage: 'Левое изображение',
    rightImage: 'Правое изображение',
    value: 'Значение',
    url: 'Ссылка',
    icon: 'Иконка',
    category: 'Категория',
    subcategory: 'Подкатегория',
    productCategoryInfo: 'Выбирайте, или категорию, или подкатегорию',
    projectType: 'Тип портфолио',
    name: 'Имя',
    comment: 'Комментарий',
    position: 'Должность',
    question: 'Вопрос',
    answer: 'Ответ',
    fullName: 'Полное имя',
    fullNameEmailTelNumberSearch: 'Поиск по имени, почте, UID или телефону',
    purchaseTransactionSearch: `Поиск по имени или почте клиента, ID транзакции или ID QR-транзакции`,
    coinTransactionSearch: `Поиск по имени или почте клиента`,
    admin: 'Администратор',
    address: 'Адрес',
    clientId: 'ID клиента',
    deliveryPrice: 'Цена доставки',
    coinsInCurrency: 'Цена для оплаты монетами в валюте',
    maxCanBePrice: 'Цена не может превышать цену заказа: {price}',
    code: 'Код',
    validTo: 'Действителен до',
    validFrom: 'Действителен от',
    discountPercent: 'Скидка в процентах',
    inPercent: 'в %',
    inMainCurrency: 'в основной валюте',
    message: 'Сообщение',
    language: 'Язык',
    descriptionShort: 'Краткое описание',
    brand: 'Бренд',
    onlineShopSection: 'Раздел интернет-магазина',
    config: 'Конфигурации',
    needExtraProduct: 'Если вам нужен этот же продукт (то есть одинаковая общая информация), но другие конфигурации (размер, объем, цвет), то добавьте доп. товар и впишите только эти изменения',
    difConfigProducts: 'Имейте в виду, что хотя бы один из параметров (размер, объем или цвет) должен отличаться друг от друга для привязки',
    otherImages: 'Другие изображения',
    addImage: 'Добавить новое изображение',
    productExample: 'Пример товара на разных языках и валютах',
    price: 'Цена',
		buyPrice: 'Себестоимость за 1',
    overprice: 'Наценка',
    showInShop: 'Показывать в интернет-магазине',
    hidden: 'Скрыть',
    homeBanner: 'Показывать в баннере магазина',
    inStock: 'В наличии',
    quantity: 'Количество',
    mainCurrency: 'Основная валюта',
    symbol: 'Символ',
    status: 'Статус',
    tag: 'Тег',
    link: 'Ссылка',
    delivery: 'Доставка',
    orderNumber: 'Номер заказа',
    cashOn: 'Оплата при',
    statusPayment: 'Статус оплаты',
    registeredAt: 'Зарегистрирован',
    client: 'Клиент',
    branch: 'Филиал',
		dateTime: 'Дата и время',
		arrivedAt: 'Прибыл в',
    order: 'Заказ',
    usedCoupon: 'Использованный купон',
    deliveryTo: 'Доставка на',
    selfDeliveryFrom: 'Самовывоз из',
    total: 'Итого',
    paymentIs: 'Оплата',
    paymentLeft: 'Осталось оплатить',
    paid: 'Оплачено',
    orderIs: 'Статус заказа',
    totalCount: 'Всего позиций',
    totalQuantity: 'Всего товаров',
    reason: 'Причина',
    orderNumOrClient: 'Номер заказа или имя, телефон, email клиента',
    titleOrClient: 'Название или имя клиента',
    content: 'Контент',
    public: 'Публичный пост',
    author: 'Автор',
    enterUrl: 'Введите ссылку',
    enterEmbedUrl: 'Введите youtube видео код (11 букв)',
    showInClientAddress: 'Показывать в секции адреса клиента',
    wholesalePrice: 'Оптовая цена',
    fromPrice: 'Цена от',
    toPrice: 'Цена до',
    forClients: 'Для клиентов',
    type: 'Тип клиента',
    productDiscountHint: 'Скидка работает только при теге "Акция"',
    productWholesalePriceHint: 'Если пустая, оптовикам покажет обычную цену',
    product: 'Товар',
    createdAt: 'Создан',
    rating: 'Оценка',
    productTitle: 'Название товара',
    thesis: 'Тезис',
    widthInPercent: 'Ширина в %',
    nodePosition: 'Позиция',
    youtubeDescription: 'Это всего лишь контейнер для видео с YouTube, и столько место он занимает. Вы не видите само видео, но он здесь. Если указали правильный ID, всё заработает. Нажмите на ссылку, если заработает значит правильно.',
    autoUse: 'Применять автоматически на заказы',
    firstOrder: 'Для первых заказов',
    toBanner: 'Показывать в баннере',
    wideImage: 'Широкая картина',
    mobileImage: 'Вертикальная картина',
    wholesale: 'оптом',
    clientNotes: 'Примечание клиента',
    amount: 'Сумма',
    couponBannerWideImageHint: `<b>Идеальный баннер - </b>16:9<br/>
Ограниченные поля - находятся в зоне риска невидимости на разных экранах. Старайтесь на этих полях оставлять "пустоту".`,
    couponBannerMobileImageHint: `<b>Идеальный баннер для вертикальных экран (2 картина)</b>:<br/>
Для вертикальных экран (мобильные телефоны): ширина / длина = 0.525 (например: ширина = 420px, длина = 800px, итого соотношение 0.525)<br/>
<b>Если простыми словами 9:16 пойдет</b>`,
    warningOrderItems: 'Внимание! Опасная зона! Если вы хотите изменить цены товаров, повлиять на стоимость заказа (например, удалить или добавить товары), убедитесь, что это согласовано с клиентом.',
    clientNotRegistered: 'Не зарегистрированный клиент',
    titleOrId: 'Название или артикул (ID)',
    volume: 'Объем',
    country: 'Страна',
    expiration: 'Срок годности',
    color: 'Цвет',
    optional: '(не обязательно)',
    colorTitle: 'Название цвета',
    brandTitle: 'Название бренда',
    categoryTitle: 'Название категории',
    subcategoryTitle: 'Название подкатегории',
    couponTitle: 'Название купона',
    commonInfo: 'Общая информация',
    commonInfoOfProducts: 'Общая информация товаров',
    duplicateProductDescription: 'Этот товар будет привязан к товарам ID',
		fromDate: 'Дата активации',
    shortFromDate: 'От даты',
		toDate: 'До даты',
		arrivalIds: 'ID поступления',
    withSpaces: 'через пробел',
		action: 'Действие',
		defaultCurrency: 'Основная валюта',
		exchangeRate: 'Курс',
		currentRateIs: 'Текущий курс: {currentRate}',
		currentCoinRateIs: 'Текущий курс монеты: {currentRate}',
    coins: 'Монеты',
    level: 'Уровень',
    updateProducts: 'Обновить цены за монеты всех товаров',
    coinsPrice: 'Цена в монетах',
    nLevelShort: '{level} ур.',
    minDirectReferrals: 'Мин. прямых рефералов',
    minNetworkPurchases: 'Мин. сетевых покупок',
    minPersonalPurchases: 'Мин. личных покупок',
    reachedBonus: 'Бонус при достижении',
    notDefined: 'Не определен',
    bonusPercent: 'Бонус в процентах',
    bonusToSenior: 'Бонус старшему рефералу',
    seniorReferralBonusPercent: 'Бонус в процентах старшим рефералам',
    balance: 'Баланс',
    paymentInCoins: 'Оплата в монетах',
    referredBy: 'Приглашен от (UID)',
    last: 'Посл.',
    quantityShort: 'Кол-во',
    allQuantity: 'Общее кол-во',
    productData: 'Данные товара в интернет-магазине',
    was: 'Было',
    margin: 'Маржа',
    totalMargin: 'Общая маржа (без вычета бонусов)',
    definedMarkup: 'Обозначенная наценка',
    markup: 'Наценка',
    addProductArrival: 'Сразу добавить поступление товара',
    addProductArrivalDesc: 'Это позволит автоматически рассчитать цены на основе себестоимости и складского учёта',
    or: 'или',
    addProductPrice: 'написать цены по своему усмотрению',
    productArrivalAdded: `Добавлен в "<b>{branchTitle}</b>", в количестве <b>{quantity}</b> и себестоимостью <b>{buyPrice}</b>,<br/>дата и время - <b>{arrivedAt}</b>`,
  },
  table: {
    color: 'Color',
    id: 'ID',
    fullName: 'ФИО',
    info: 'Информация',
    email: 'Почта',
    telNumber: 'Тел. номер',
    userGroup: 'Группа',
    active: 'Активные',
    privileges: 'Привилегии',
    title: 'Название',
    actions: 'Действия',
    type: 'Тип',
    price: 'Стоимость',
    overprice: 'Наценка',
    wholesalePrice: 'Оптом',
    category: 'Категория',
    amount: 'Сумма',
    paymentType: 'Тип оплаты',
    currency: 'Валюта',
    num: '№',
    supervisor: 'Супервайзор',
    executor: 'Исполнитель',
    where: 'Где',
    description: 'Описание',
    createdAt: 'Создано',
    deadline: 'Срок',
    status: 'Статус',
    priority: 'Приоритет',
    number: 'Номер',
    numberType: 'Тип номера',
    cleaning: 'Уборка',
    checkIn: 'Заезд',
    checkOut: 'Выезд',
    guestFullName: 'ФИО гостя',
    cleanerFullName: 'ФИО клинера',
    adults: 'Взрослые',
    subtitle: 'Подзаголовок',
    children: 'Дети',
    bookingStatus: 'Статус брони',
    numberStatus: 'Статус номера',
    notes: 'Примечание',
    expFrom: 'Опыт с',
    isAboutPage: 'Страница "О нас"',
    showInHome: 'Страница "Главная"',
    isService: 'Страница "Услуги"',
    percent: 'Процент',
    telegram: 'Telegram',
    whatsapp: 'WhatsApp',
    showIn: 'Показывать в',
    isMain: 'Является основным',
    value: 'Значение',
    name: 'Имя',
    position: 'Должность',
    question: 'Вопрос',
    admin: 'Администратор',
    banned: 'Заблокирован',
    address: 'Адрес',
    discount: 'Скидка',
    validTo: 'Действителен',
    fromSite: 'С сайта',
    mainCurrency: 'Основная валюта',
    symbol: 'Символ',
    usingInSystem: 'Используется в системе',
    code: 'Код',
    showInShop: 'Показывается в интернет-магазине',
    tag: 'Тег',
    volume: 'Объем',
    profession: 'Профессия',
    client: 'Клиент',
    cashOn: 'Оплата при',
    payment: 'Оплата осталось',
    delivery: 'Доставка',
    registeredAt: 'Зарегистрирован',
    orderNum: 'Номер заказа',
    yes: 'Есть',
    no: 'Нет',
    rating: 'Рейтинг',
    product: 'Товар',
    timeToRead: 'Время для чтения',
    words: 'Кол-во слов',
    minRead: 'мин чтения',
    public: 'Публичный',
    wholesale: 'оптом',
    fromPrice: 'Цена от',
    forClients: 'Для клиентов',
    quantity: 'Количество',
    repliesCount: 'Ответы',
    comment: 'Комментарий',
    tags: 'Тэги',
    from: 'от',
    to: 'до',
    discountType: 'Тип скидки',
    pricePriceDiscount: 'Цена (цена без скидки)',
    paid: 'Оплачено',
    brand: 'Бренд',
    subcategory: 'Подкатегория',
		fromDate: 'Дата активации',
		defaultCurrency: 'Основная валюта',
		branch: 'Филиал',
		arrivedAt: 'Время прибытия',
		buyPrice: 'Себестоимость за 1',
		note: 'Примечание',
    level: 'Уровень',
    minDirectReferrals: 'Мин. прямых рефералов',
    minNetworkPurchases: 'Мин. сетевых покупок',
    minPersonalPurchases: 'Мин. личных покупок',
    reachedBonus: 'Бонус при достижении',
    bonusOrder: 'Бонус от покупки',
    refBonus: 'Бонус старшему рефералу',
    nLevelShort: '{level} ур.',
    uid: 'UID',
    referredBy: 'Приглашен от',
    balance: 'Баланс',
    directReferrals: 'Прямые рефералы',
    totalEarnedCoins: 'Всего заработано монет',
    totalPersonalPurchases: 'Всего личных покупок',
    totalNetworkPurchases: 'Всего сетевых покупок',
    paymentId: 'ID транзакции',
    dateTime: 'Дата и время',
    qrTransactionId: 'ID QR-транзакции',
    transaction: 'Транзакция',
    coinId: `ID монеты`,
    purchaseId: 'ID деньги',
    fromToPrice: 'От/до цена',
    mainInfo: 'Основная информация',
    user: 'Пользователь',
    data: 'Данные',
    language: 'Язык'
  },
  buttons: {
		moveTo: 'Переместить в',
    selectAll: 'Выбрать всё',
    reload: 'Перезагрузить',
    exportCatalog: 'Экспорт в XLSX',
    logout: 'Выйти',
    disclose: 'Раскрыть',
    close: 'Закрыть',
    reset: 'Сбросить',
    form: 'Сформировать',
    remove: 'Удалить',
    delete: 'Удалить',
    setMain: 'Сделать основным',
    main: 'Основной',
    translate: 'Перевести',
    rephrase: 'Перефразировать',
    revoke: 'Оменить',
    generateFromDescription: 'Сгенерировать из описании',
    addExtraProduct: 'Добавить доп. товар',
    deleteExtraProduct: 'Удалить доп. товар',
    recover: 'Восстановить',
    save: 'Сохранить',
    cancel: 'Отмена',
		cancel2: 'Отменить',
    create: 'Создать',
    add: 'Добавить',
    back: 'Назад',
    edit: 'Редактировать',
    restore: 'Восстановить',
    editPrices: 'Редактировать цены и параметры',
    editInfo: 'Редактировать общую информацию',
    makeDuplicate: 'Дублировать и привязать',
    connectProducts: 'Привязать товары друг к другу',
    copyData: 'Копировать и создать новую',
    preview: 'Ссылка',
    view: 'Посмотреть',
    movement: 'Переезд',
    checkIn: 'Заезд',
    checkOut: 'Выезд',
    payment: 'Оплата',
    invoiceForPayment: 'Счёт к оплате',
    invoice: 'Счёт фактура',
    confirmationInvoice: 'Подтверждение брони',
    addPayment: 'Добавить оплату',
    closeShift: 'Закрыть смену',
    sendToCashBox: 'Перевод в кассу',
    transferShift: 'Приём-передача',
    collectionShift: 'Инкассация',
    submit: 'Подтвердить',
    getShift: 'Принять смену',
    send: 'Отправить',
    openShift: 'Открыть смену',
    collect: 'Изъять',
    actions: 'Действия',
    forgotYourPassword: 'Забыли пароль?',
    login: 'Войти',
    ban: 'Заблокировать',
    unban: 'Разблокировать',
    yes: 'Да',
    clear: 'Очистить',
    makeAnswered: 'Отметить как отвеченное',
    answerLater: 'Ответить позже',
    confirm: 'Подтвердить',
    details: 'Детали',
    use: 'Использовать',
    unuse: 'Не использовать',
    menu: 'Меню',
    changeStatus: 'Изменить статус',
    showPayments: 'Список оплат',
    showItems: 'Список товаров',
    complete: 'Завершить',
    register: 'Зарегистрировать',
    return: 'Вернуть',
    images: 'Изображения',
    enterImageUrl: 'Введите ссылку изображения',
    enterVideoUrl: 'Введите ссылку видео',
    select: 'Выбрать',
    createFolder: 'Создать папку',
    uploadFiles: 'Загрузить файлы',
    uploadImage: 'Вставить картинку',
    addFiles: 'Добавить файлы',
    upload: 'Загрузить',
    link: 'Привязать',
    unlink: 'Отвязать',
    showReplies: 'Список ответов',
    linkToClient: 'Привязать к клиенту',
    editBalance: 'Редактировать баланс',
    sendBonus: 'Отправить бонус',
    bonusSent: 'Бонус отправлен'
  },
  $vuetify: {
    badge: 'знак',
    close: 'Закрыть',
    dataIterator: {
      noResultsText: 'Не найдено подходящих записей',
      loadingText: 'Запись загружается...',
    },
    dataTable: {
      itemsPerPageText: 'Строк на странице:',
      ariaLabel: {
        sortDescending: 'Упорядочено по убыванию.',
        sortAscending: 'Упорядочено по возрастанию.',
        sortNone: 'Не упорядочено.',
        activateNone: 'Активируйте, чтобы убрать сортировку.',
        activateDescending: 'Активируйте для упорядочивания убыванию.',
        activateAscending: 'Активируйте для упорядочивания по возрастанию.',
      },
      sortBy: 'Сортировать по',
    },
    dataFooter: {
      itemsPerPageText: 'Записей на странице:',
      itemsPerPageAll: 'Все',
      nextPage: 'Следующая страница',
      prevPage: 'Предыдущая страница',
      firstPage: 'Первая страница',
      lastPage: 'Последняя страница',
      pageText: '{0}-{1} из {2}',
    },
    datePicker: {
      itemsSelected: '{0} выбран',
      nextMonthAriaLabel: 'Следующий месяц',
      nextYearAriaLabel: 'Следующий год',
      prevMonthAriaLabel: 'Прошлый месяц',
      prevYearAriaLabel: 'Предыдущий год',
    },
    noDataText: 'Отсутствуют данные',
    carousel: {
      prev: 'Предыдущий слайд',
      next: 'Следующий слайд',
      ariaLabel: {
        delimiter: 'Слайд {0} из {1}',
      },
    },
    calendar: {
      moreEvents: 'Еще {0}',
    },
    input: {
      clear: 'Очистить {0}',
      prependAction: '{0} добавленное действие',
      appendAction: '{0} добавленное действие',
    },
    fileInput: {
      counter: 'Файлов: {0}',
      counterSize: 'Файлов: {0} (всего {1})',
    },
    timePicker: {
      am: 'AM',
      pm: 'PM',
    },
    pagination: {
      ariaLabel: {
        wrapper: 'Навигация по страницам',
        next: 'Следующая страница',
        previous: 'Предыдущая страница',
        page: 'Перейти на страницу {0}',
        currentPage: 'Текущая страница, Страница {0}',
      },
    },
    rating: {
      ariaLabel: {
        icon: 'Рейтинг {0} из {1}',
      },
    },
    loading: 'Загрузка...',
  },
};
